/** Sentinel understood by Eshop (`override_to == 'NOMAIL'` → skip send). */
export const OVERRIDE_TO_NOMAIL = 'NOMAIL';

export const MODE_NONE = 'none';
export const MODE_NOMAIL = 'nomail';
export const MODE_CUSTOM = 'custom';

/**
 * Map stored override_to → UI mode.
 * @param {unknown} value
 * @returns {'none'|'nomail'|'custom'}
 */
export function mode_from_override_to(value) {
    if (value === OVERRIDE_TO_NOMAIL)
        return MODE_NOMAIL;
    if (value != null && String(value).trim() !== '')
        return MODE_CUSTOM;
    return MODE_NONE;
}

/**
 * Map UI mode (+ optional custom address) → stored override_to.
 * @param {'none'|'nomail'|'custom'} mode
 * @param {string} [custom_email]
 * @returns {string|null}
 */
export function value_from_mode(mode, custom_email = '') {
    if (mode === MODE_NOMAIL)
        return OVERRIDE_TO_NOMAIL;
    if (mode === MODE_CUSTOM) {
        const trimmed = String(custom_email || '').trim();
        return trimmed || '';
    }
    return null;
}
